<template>
    <div class="grid grid-col lg:grid-row lg:grid-cols-2 2xl:grid-cols-[1fr_auto] gap-2 place-items-center" data-section-theme="none">
        <div class="grid mx-auto p-4 w-full lg:w-2/3 lg:max-w-[600px]">
            <div class="text-center mb-4">
                <h2>Family Memories Start Here</h2>
                <p>Sign in to your account to find your photos.</p>
            </div>

            <form @submit.prevent="login" method="post" class="mt-3">
                <div class="p text-leonard-error mb-4" v-if="has_error" v-html="errorText"></div>

                <div class="grid grid-flow-row gap-3">
                    <label class="block">
                        <span class="text-sm">Username</span>
                        <input type="text" id="username" class="w-full bg-leonard-white placeholder:text-leonard-black-disabled text-leonard-black rounded lg:rounded-md p-4 border border-leonard-grey-disabled focus:outline-none focus:border-leonard-black-hover" placeholder="Username" autocomplete="username" v-model="username" required>
                    </label>
                    <label class="block">
                        <span class="text-sm">Password</span>
                        <input type="password" class="w-full bg-leonard-white placeholder:text-leonard-black-disabled text-leonard-black rounded lg:rounded-md p-4 border border-leonard-grey-disabled focus:outline-none focus:border-leonard-black-hover" placeholder="Password" autocomplete="current-password" v-model="password" required>
                    </label>
                </div>
                <div class="grid grid-cols-[1fr_auto] place-items-start items-center my-6 gap-3">
                    <p><router-link :to="{name: 'forgot-password'}" class="underline text-leonard-green hover:text-leonard-green-hover hover:no-underline">
                        Forgot your password?
                    </router-link></p>

                    <button type="submit" :disabled="loading" class="font-medium transition-all duration-300 border-2 rounded-md inline-block py-2 px-3 md:px-4 bg-leonard-green border-leonard-green text-leonard-white hover:bg-leonard-green-hover hover:border-transparent focus:ring-leonard-green cursor-pointer disabled:bg-leonard-green-disabled disabled:text-leonard-green disabled:cursor-not-allowed">
                        Sign In
                        <font-awesome-icon fixed-width icon="spinner" spin v-if="loading"></font-awesome-icon>
                    </button>
                </div>

                <hr class="my-4"/>

                <p class="text-center">Don't have an account? <router-link :to="{name: 'register'}" class="underline text-leonard-green hover:text-leonard-green-hover hover:no-underline">Register instead</router-link></p>
            </form>
        </div>

        <div id="login_image_wrapper" class="hidden lg:block">
            <img src="" aria-hidden="true" alt="Student Ambassador Portrait" id="login_image" class="w-full h-full object-cover">
        </div>
    </div>
</template>

<script>
import {library} from '@fortawesome/fontawesome-svg-core';
import {faSpinner, faLock, faAngleRight} from '@fortawesome/free-solid-svg-icons';
import Content from '../../classes/Content';
import Alert from '../app/Alert.vue';

export default {
    data() {
        return {
            images: [],
            errorText: "",
            has_error: false,
            loading: false,
            username: null,
            password: null,
        };
    },
    created() {
        library.add(faSpinner, faLock, faAngleRight);
    },
    mounted() {
        this.getImages();
    },
    methods: {
        getRandomInt(max) {
            return Math.floor(Math.random() * Math.floor(max));
        },
        getImages() {
            let self = this;
            let content = new Content();
            content.getSeniorImages().then(function (response) {
                self.images = response.data;
                self.applyImage();
            });
        },
        applyImage() {
            const imgEl = this.$el.querySelector("#login_image");
            let r = this.getRandomInt(this.images.length);
            imgEl.src = this.images[r].image_path;
            imgEl.alt = this.images[r].description;
            imgEl.style.opacity = 1;
        },
        login() {
            const self = this;
            const redirect = this.$auth.redirect();
            this.loading = true;
            this.has_error = false;
            this.$auth.login({
                data: {
                    username: self.username,
                    password: self.password
                },
                success: function (response) {
                    self.loading = false;
                    self.$auth.user(response.data.data);
                    if (self.$route.query.ac) {
                        self.$router.push({name: "order", query: {"auto": 1}});
                    }
                    if (self.$router.currentRoute.name !== "home" && !self.$route.query.ac) {
                        self.$router.push({name: redirect && redirect.from.name !== "login" ? redirect.from.name : "order"});
                    }
                    feedback("Successfully Logged In", "success");
                },
                error: function (err) {
                    console.error("Error signing in: ", err.response.data.message);
                    self.loading = false;
                    self.has_error = true;
                    self.errorText = err.response.data.message || "Invalid Credentials. Please check your email and password and try again.";
                },
                rememberMe: false,
                fetchUser: false
            });
        },
    },
    components: {Alert}
}
</script>

<style lang="scss" scoped>
#login_image_wrapper {
    background: url('/images/login_placeholder.jpg') no-repeat;
    background-size: cover;
    min-width: 33.333%;
    min-height: 500px;
}

#login_image {
    opacity: 0;
    transition: opacity 1s;
}
</style>
